import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Landing from '../components/Landing'
import { Home } from '../components/Home'
import Login from '../components/Login'
import Recover from '../components/ForgotPasswordForm'
import AceptarPresupuesto from '../components/AceptarPresupuesto'
/* import { PrivateRoutes } from './PrivateRoutes' */


export const AppRouter = () => {

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/recover" element={<Recover />} />
        <Route
          path="/aceptar-presupuesto"
          element={<AceptarPresupuesto />}
        />
        <Route path="/*" element={<Home />} />
      </Routes>
    </>
  )
}